export default __webpack_public_path__ + "static/media/home-figures.61950518.JPG";